import React from 'react';
import { NotificationEvents } from 'modules/messaging';
import { connect, ConnectedProps } from 'react-redux';
import { GlobalApplicationState } from 'globalApplicationState';
import {actions} from '../..';
import * as audiencesActions from "modules/audiences/actionCreator";
import SMSSendInvites from '../smsSendInvites';
import { useSetSnackbarMessages } from 'modules/common/hooks/useSetSnackbarMessages';
import { Audience } from 'modules/audiences';
import { FileDownloader } from 'utils/fileDownloader';
import AutomaticSubscriptionAudiencesSection from '../automaticSubscriptionAudiencesSection';
import VerifyInviteAudiencesSection from '../verifyInviteAudiencesSection';
import SMSVerifyEditorSection from '../smsVerifyEditorSection';

interface IMessagingSMSControlsProps { }

const MessagingSMSControls: React.FC<IConnectedSMSManagementPageProps> = ({
    notificationSettings,
    audiences,
    isSaving,
    isFetching,
    smsBodies,
    defaultLCID,
    setSMSBody,
    getAudienceUsersForCSV,
    setOptInInviteAudiences,
    setAutomaticOptInAudiences
}) => {

    const { setSuccessMessage, setErrorMessage } = useSetSnackbarMessages();
    const [optInOpen, setOptInOpen] = React.useState(false);
    const [lastCheckOpen, setLastCheckOpen] = React.useState(false);

    const createAudienceMapFromIds = (audienceIds: string[], allAudiences: Audience[]) => {
        const selectedAudiences = allAudiences.filter(a => audienceIds.includes(a.id));
        return selectedAudiences.map(a => ({id: a.id, name: a.displayName}))
    }

    const optInInviteAudiences = createAudienceMapFromIds(notificationSettings.optInInviteAudiences ?? [], audiences)
    const automaticOptInAudiences = createAudienceMapFromIds(notificationSettings.automaticOptInAudiences ?? [], audiences)

    const getAudienceUsersCSV = (audienceIds: string[], filename: string) => {
        const file = {name: filename};
        getAudienceUsersForCSV(audienceIds)
            .then((userData) => {
            if (!!userData) new FileDownloader(file).downloadBlob(userData)
            setSuccessMessage("Employee list for selected audiences downloaded. Check your Downloads folder.");
        });
    }
    return (
        <React.Fragment>
            <AutomaticSubscriptionAudiencesSection
                audiences={audiences}
                automaticOptInAudiences={automaticOptInAudiences}
                isFetching={isFetching}
                setAutomaticOptInAudiences={setAutomaticOptInAudiences}
                getAudienceUsersCSV={getAudienceUsersCSV}
            />

            <VerifyInviteAudiencesSection 
                audiences={audiences}
                optInInviteAudiences={optInInviteAudiences}
                isFetching={isFetching}
                setOptInInviteAudiences={setOptInInviteAudiences}
                getAudienceUsersCSV={getAudienceUsersCSV}
            />

            <SMSVerifyEditorSection 
                notificationSettings={notificationSettings}
                smsBodies={smsBodies}
                defaultLCID={defaultLCID}
                isSaving={isSaving}
                setSMSBody={setSMSBody}
                setOptInOpen={setOptInOpen}
            />

            <SMSSendInvites 
                audiences={audiences}
                optInOpen={optInOpen}
                smsBodies={smsBodies}
                setOptInOpen={setOptInOpen}
                lastCheckOpen={lastCheckOpen}
                setLastCheckOpen={setLastCheckOpen}
                optInTranslation={notificationSettings.settings[NotificationEvents.VerifySMSPhone]}
                setSuccessMessage={setSuccessMessage}
                setErrorMessage={setErrorMessage}
                defaultLCID={defaultLCID}
            />

        </React.Fragment>
    )
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: IMessagingSMSControlsProps) => ({
        ...ownProps,
        notificationSettings: state.settings.notificationSettings,
        smsBodies: state.resources.smsBodiesResource,
        audiences: state.audiences.audiences,
        isFetching: state.audiences.isFetching,
        isSaving: state.settings.saving,
        defaultLCID: state.settings.clientSettings.defaultLCID
    }),
    {
        setSMSBody: actions.SetSMSBody,
        setOptInInviteAudiences: actions.setOptInInviteAudiences,
        setAutomaticOptInAudiences: actions.setAutomaticOptInAudiences,
        getAudienceUsersForCSV: audiencesActions.downloadAudienceUsersCSV
    }
);
type IConnectedSMSManagementPageProps = ConnectedProps<typeof connector>;

export default connector(MessagingSMSControls);